/**
 * comments functionality
 */

import "./index.scss";

import { loadComments } from './utils/load-comments';
import { updateCommentsCounters } from './utils/update-counters';
import CommentForm from './comment-form/comment-form';
import { getComment } from "./utils/comment";
import { initLoader } from "./comment-form/comment-form-loader";
import { triggerEvent } from "../../../services/helpers/trigger-event";


/**
 * Добавить HTML нового комментария в начало списка
 * И прокрутить к нему
 * @param {string} comment 
 * @param {HTMLElement} list 
 */
const addCommentToList = (comment, list) => {
    list.insertAdjacentHTML('afterBegin', comment);
    list.firstElementChild.scrollIntoView({
        behavior: "smooth",
        block: "center"
    });
}

// обновляет счетчики комментариев у поста
const updateCounters = updateCommentsCounters();

// форма комментирования (ответ, редактирование, удаление)
let commentsForm;

/* Нажатие на кнопку ответить */
const replyToComment = function (el) {
    /* родительский комментарий */
    let commentEntity = getComment(el);
    if (!commentEntity) return;

    /**
     * Если форма уже открыта
     */
    let text = '';
    if (commentsForm.entity) {
        // не переоткрывать форму ответа у того же коммента
        if (commentsForm.state == "answer" && commentsForm.entity == commentEntity) return;

        // если пользователь редактирует комментарий, показать скрытый комментарий
        if (commentsForm.state == "edit") {
            showEntityAfterEdit(commentsForm.entity);
        } else if (commentsForm.state == "answer") {
            /**
             * Если пользователь уже отвечает на другой комментарий,
             * скопировать набранный текст в форму ответа
             */
            
            text = commentsForm.text;
        }
    }

    commentsForm.clear();
    commentsForm.entity = commentEntity;
    commentsForm.state = "answer";
    commentsForm.text = text;

    commentEntity.element.appendChild(commentsForm.form);

    commentsForm.focus();
};

const hideEntityForEdit = function(entity) {
    entity.element.style.display = "none";
};

const showEntityAfterEdit = function(entity) {
    entity.element.style.display = "";
};

/* Нажатие на кнопку Редактировать комментарий */
const editComment = function editComment(el) {
    return new Promise((resolve) => {
        let commentEntity = getComment(el);
        if (!commentEntity) return;

        /**
         * Если форма уже открыта
         */
        if (commentsForm.entity) {
            // если пользователь редактирует комментарий
            if (commentsForm.state == "edit") {
                if (commentsForm.entity == commentEntity) {
                    resolve();
                    return;
                } else {
                    // показать скрытый для редактирования комментарий
                    showEntityAfterEdit(commentsForm.entity);
                }
                
            }

            commentsForm.clear();
        }

        commentsForm.entity = commentEntity;
        commentsForm.state = "edit";

        commentEntity.getData()
            .then(response => {
                // установить данные комментария
                commentsForm.setData(response);

                triggerEvent(document.body, "remove.modal");

                // вставить форму рядом с блоком комментария
                // блок скрыть
                commentEntity.element.parentElement.insertBefore(commentsForm.form, commentEntity.element);
                commentsForm.focus();
                
                hideEntityForEdit(commentEntity);

                resolve();
            })
            .catch(e => {
                console.error(e);
                resolve()
            });
    })   
}

/* Нажатие на кнопку Удалить комментарий */
let deleteComment = function deleteComment(el) {
    return new Promise((resolve, reject) => {
        let commentEntity = getComment(el);
        if (!commentEntity) return;

        window.confirm({ 
            question: "Это действие безвозвратно удалит ваш комментарий",  
            confirmButton: "Удалить",
        }).then(() => {
            commentEntity.delete()
                .then(response => {
                    updateCounters(response.count);
                    resolve();
                })
                .catch(e => {
                    console.error(e);
                    resolve();
                });
        }).catch((err) => reject(err));
    });
};

const initCommentsFeed = () => {
    // форма уже выведена для какого-то комментария
    let blocked;

    // главная ветка комментариев (вставка новых комментов)
    const commentsList = document.querySelector('.comments-feed');

    if (commentsList) {
        loadComments(commentsList);
    }

    // форма создания новых комментариев
    let createForm = document.getElementById('create-comment-form');
    if (createForm) {
        initLoader(createForm, "commentFiles[]");
        new CommentForm(createForm, {
            onCommentCreate: function(res) {
                if (res.count) updateCounters(res.count);
                addCommentToList(res.html, commentsList);
                this.clear();
                document.body.dispatchEvent(new Event('feed.events.update'));
            }
        });
    }

    // форма комментариев (ответ, редактирование, удаление)
    let commentsFormElement = document.getElementById('comments-form');
    if (commentsFormElement) {
        initLoader(commentsFormElement, "commentFiles[]");
        commentsForm = new CommentForm(commentsFormElement, {
            onCommentCreate: function (res) {
                if (res.count) updateCounters(res.count);
                let entity = this.entity;
                if (entity) {
                    if (commentsForm.state == "edit") {
                        entity.updateComment(res.html);
                    } else {
                        addCommentToList(res.html, entity.children);
                    }
                    entity = null;
                    this.entity = null;
                    document.body.dispatchEvent(new Event('feed.events.update'));
                }

                this.close();
                this.clear();
            },
            onCancelEdit: () => {
                this.close();
                this.clear();
                if (this.entity) {
                    showEntityAfterEdit(this.entity);
                }
            }
        });
    }



    document.addEventListener('click', function (e) {
        if (blocked) return;

        /* кнопка Ответить */
        if (e.target.hasAttribute('data-comment-reply')) {
            replyToComment(e.target);
        }

        /* кнопка удалить */
        let deleteButton = e.target.closest('[data-comment-delete]');
        if (deleteButton) {
            
            if (deleteButton.blocked) return;
            deleteButton.blocked = true;
            deleteButton.setAttribute('data-loading', '');
            blocked = true;
            
            deleteComment(deleteButton)
                .then(() => {
                    deleteButton.removeAttribute('data-loading');
                    deleteButton.blocked = false;
                    blocked = false;
                })
                .catch(() => {
                    deleteButton.removeAttribute('data-loading');
                    deleteButton.blocked = false;
                    blocked = false;
                });
        }

        /* кнопка редактировать */
        let editButton = e.target.closest('[data-comment-edit]');
        if (editButton) {
            if (editButton.blocked) return;
            editButton.blocked = true;
            editButton.setAttribute('data-loading', '');
            blocked = true;
            editComment(editButton)
                .then(() => {
                    editButton.removeAttribute('data-loading');
                    editButton.blocked = false;
                    blocked = false;
                });
        }

        /* прокрукта к родителю */
        let toParentButton = e.target.closest('[data-to-parent]');
        if (toParentButton) {
            let parent = document.querySelector(`[data-id="${toParentButton.dataset.toParent}"]`);
            if (parent) {
                parent.classList.remove('highlight');
                setTimeout(() => {
                    parent.classList.add('highlight');
                }, 0)
            }
            
        }
    });
};

onDomReady.then(() => initCommentsFeed());